import iComplyLogo from "../../../assets/images/icomply.png";
import realestateLogo from "../../../assets/images/realestate.png";
import { CHOOSE_PLAN_ROUTE } from "../../../routes";
const FooterSection = (props) => {
    return (
        <footer
            id="footer"
            className="text-white ui-7 w-100"
            style={{ padding: "4rem 0" }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <img
                            className="d-block img-fluid"
                            style={{ maxHeight: "3rem" }}
                            src={iComplyLogo}
                            alt=""
                        />
                        <a target="_blanl" href="https://www.reet.net.au/">
                            <img
                                className="d-block mt-5 img-fluid"
                                style={{ maxHeight: "3rem" }}
                                src={realestateLogo}
                                alt=""
                            />
                        </a>
                        <h5 className="text-primary mt-5">
                            Intelligent compliance
                        </h5>
                        <p className="text-body-2" style={{maxWidth:"40ch"}}>
                            iComply provides this website as a service to real 
                            estate agents and their employees. 
                            iComply is not responsible for, and
                            expressly disclaims all liability for, damages of
                            any kind arising out of use, reference to, or
                            reliance on any information contained within this
                            website.
                        </p>
                    </div>
                    <div className="col-lg">
                        <h5 className="text-primary mt-2 ">
                            Address
                        </h5>
                        <p className="text-body-1">
                            <b>iComply</b><br/>
                            WTL Building Level 4<br/>
                            Suite 408/83 York Street, Sydney<br/>
                            NSW 2000<br/>
                        </p>
                    </div>
                    <div className="col-lg">
                        <h5 className="text-primary mt-2">
                            Phone
                        </h5>
                        <p className="text-body-1">+61 02 8324 1407</p>
                    </div>
                    <div className="col-lg">
                        <ul className="list-unstyled remove-top-margin">
                            {props.links}
                        </ul>
                    </div>
                    <div className="col-lg">
                        <button style={{height:"3rem"}} onClick={()=>props.history.push(CHOOSE_PLAN_ROUTE)} className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn">Get Started</button>
                        {/* <button style={{height:"3rem"}} className="btn btn-primary rounded-pill px-5 text-btn text-white text-nowrap">
                            Get Started
                        </button> */}
                    </div>
                </div>
                <div className="text-center mt-4">
                    Compliance Education & Training Pty Ltd ABN 25 650 834 905
                </div>
            </div>
        </footer>
    );
};

export default FooterSection;
